import lodash from 'lodash'
import { useCallback } from 'react'

import { useOpenModal } from 'components/uiKit/Modal'
import { EDITOR_PATHS } from 'constants/paths'
import { BlockModeEnum } from 'gql/__generated__/graphql'
import { usePathParams } from 'routes/hooks'
import { updateBlock } from 'services/Store/Project/actions'
import { SectionTypeEnum } from 'services/Store/Project/enums'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getBlock, getProject, getSection } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import { cloneBlockSchema } from 'utils/editor/clone'

import TemplatePickerModal from './TemplatePickerModal/TemplatePickerModal'
import { TemplatePickerModalType, TemplatePickerMode } from './TemplatePickerModal/types'

export const useChangeTemplate = () => {
  const dispatch = useProjectDispatch()
  const block = useProjectContext(getBlock)
  const project = useProjectContext(getProject)
  const { type } = useProjectContext(getSection) || { type: SectionTypeEnum.landing }

  const onChange = useCallback(
    (block: Block) => dispatch(updateBlock({ id: block.uuid, value: block })),
    [dispatch],
  )

  const { companyId, projectId, sectionId } = usePathParams(EDITOR_PATHS.main)
  const templatePickerModal = useOpenModal(TemplatePickerModal, {
    sectionId,
    mode: TemplatePickerMode.change,
    sectionType: type,
    modalType: TemplatePickerModalType.change,
    employeePreferences: project?.employeePreferences,
    blockMode: SectionTypeEnum.test === type ? [block?.mode || BlockModeEnum.view] : undefined,
  })
  const changeTemplate = async () => {
    const val = await templatePickerModal.open({
      mode: TemplatePickerMode.change,
      companyId,
      projectId,
    })
    const template = val?.template?.blocks[0]

    if (template) {
      const newValue = cloneBlockSchema(template)
      const payload = {
        ...block,
        ...lodash.pick(newValue, ['schema', 'elements', 'name', 'mode', 'createdWith']),
      }
      onChange(payload as Block)
    }
  }
  return changeTemplate
}
